import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import {Box, Button, Link, Stack, Typography} from '@mui/material';
import parse from 'html-react-parser';
import * as React from 'react';
import {useState} from 'react';
import axios from '../../axios';
import {
  formatHour,
  formatToVcalendarDate,
  removeHtml,
  shortDateFormat,
  truncateStr,
} from '../Service';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import EventComment from '../event/EventComment';
import {useSynchronisation} from '../event/hooks/useSynchronisation';
import {useComments} from './hooks/useComments';
import {useJoin} from './hooks/useJoin';
import {useLikeCount} from './hooks/useLike';
import {withJoinContext} from './joinContext';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import {useNavigate} from 'react-router-dom';

const EventExpandLess = ({theEvent, expandMore, handleToggleClick}) => {
  const {createEvent, deleteEvent, createCalendar} = useSynchronisation();
  const [expandComment, setExpandComment] = useState(false);
  const handleToggleComment = () => {
    setExpandComment(!expandComment);
  };
  const navigate = useNavigate();
  const {commentCount} = useComments(theEvent.id);
  const {likeCount} = useLikeCount('event', theEvent.id);
  const {mode} = useDarkMode();
  const {join, joinStatus, leave} = useJoin({
    isJoin: theEvent.hasJoin,
    memberCount: 0,
  });
  const handleClickJoin = isJoin => {
    if (isJoin) {
      join(theEvent.id);
      createEvent(
          removeHtml(theEvent.description),
        theEvent.title.text,
        formatToVcalendarDate(theEvent.start_date),
        formatToVcalendarDate(theEvent.end_date),
        theEvent.location.text,
        theEvent.id,
      );
    } else {
      deleteEvent(theEvent.id);
      leave(theEvent.id);
    }
  };

  return (
    <Stack
      direction="column"
      justifyContent="left"
      alignItems="flex-start"
      sx={{height: 'auto', gap: 2}}>
      <Stack
        direction="row"
        justifyContent="left"
        alignItems="flex-start"
        flexGrow={1}
        gap={5}
        sx={{width: '100%'}}
        flexWrap={'wrap'}>
        <Box
          sx={{
            backgroundImage: `url(${axios.defaults.apiBaseURL}/${theEvent.image.uri}) , url(${process.env.REACT_APP_DEV_HOST}/assets/img/service0.jpg)`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderRadius: 1,
            width: {xs: '100%', md: '100%', lg: '350px'},
            height: {xs: '500px', md: '500px', lg: '275px'},
          }}
        />
        <Stack
          direction="column"
          sx={{height: '100%', flexGrow: 1, width: '50%'}}
          spacing={1.8}>
          <Typography className={'actualityHeaderContainer'}>
            <Typography
              component={'div'}
              className={'actualityCommunityName'}
              style={{color: mode.settings.textColor6}}>
              {theEvent.community.name}
            </Typography>
            <Button
              className="btn-gradient"
              variant="contained"
              size="large"
              endIcon={
                <RemoveRedEyeIcon
                  role={'img'}
                  aria-label="Voir le détail de la communauté"
                />
              }
              sx={{width: 75, height: 37, marginRight: 2}}
              onClick={() => navigate(`/community/${theEvent.community.id}`)}>
              <Typography variant={'subtitle3'}>Voir</Typography>
            </Button>
          </Typography>
          <Link
            href={`#event-${theEvent.id}`}
            id={`event-${theEvent.id}`}
            sx={{textDecoration: 'none'}}>
            <Typography variant="h3" color={mode.settings.textColor3}>
              {parse(theEvent.title.text)}
            </Typography>
          </Link>
          {
              shortDateFormat(theEvent.start_date) !== shortDateFormat(theEvent.end_date) ?
                  <Stack
                      direction="row"
                      justifyContent="left"
                      alignItems="flex-end"
                      flexWrap={'wrap'}
                      sx={{color: mode.settings.textColor6}}
                  >
                    <CalendarMonthIcon
                        sx={{marginRight: 0.5}}
                        aria-label={"Date de début de l'évenement"}></CalendarMonthIcon>
                    <Typography variant={'subtitle3'}>
                      {shortDateFormat(theEvent.start_date)}
                    </Typography>
                    <Typography variant={'subtitle3'} sx={{marginRight: 2}}>
                      &nbsp;à&nbsp;
                      {formatHour(theEvent.start_date)} au&nbsp;
                      {
                          shortDateFormat(theEvent.end_date) + ' à ' + formatHour(theEvent.end_date)
                      }
                    </Typography>
                    <Stack direction={'row'}>
                      <LocationOnIcon
                          aria-label={"Lieu de l'évenement"}></LocationOnIcon>
                      <Typography variant={'subtitle3'}>
                        {theEvent.location.text}
                      </Typography>
                    </Stack>
                  </Stack> :
                  <Stack
                      direction="row"
                      justifyContent="left"
                      alignItems="flex-end"
                      sx={{color: mode.settings.textColor6}}
                      flexWrap={'wrap'}>
                    <CalendarMonthIcon
                        sx={{marginRight: 0.5}}
                        aria-label={"Date de début de l'évenement"}></CalendarMonthIcon>
                    <Typography variant={'subtitle3'}>
                      {shortDateFormat(theEvent.start_date)}
                    </Typography>
                    <AccessTimeIcon
                        sx={{marginLeft: 2, marginRight: 0.5}}
                        aria-label={"Heure de l'évenement événement"}></AccessTimeIcon>
                    <Typography variant={'subtitle3'} sx={{marginRight: 2}}>
                      {formatHour(theEvent.start_date)} à&nbsp;
                      {formatHour(theEvent.end_date)}
                    </Typography>
                  <Stack direction={'row'}>
                      <LocationOnIcon aria-label={'Lieu'}></LocationOnIcon>
                      <Typography variant={'subtitle3'}>{theEvent.location.text}</Typography>
                  </Stack>
                  </Stack>
          }


          <Typography
            variant={'subtitle3'}
            sx={{marginLeft: '2px !important', width: '95%'}}
            color={mode.settings.textColor3}>
            {truncateStr(
              parse(
                theEvent.description
                  .replaceAll(/<[^>]+>/g, '')
                  .replaceAll('&nbsp;', ' '),
              ),
              125,
            )}
          </Typography>

          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="flex-end"
            sx={{
              color: '#DD809D',
              width: '95%',
              backgroundColor: mode.settings.card3BackgroundColor,
              padding: 1.5,
              borderRadius: 1,
            }}
            flexWrap={'wrap'}>
            <Stack
              direction="row"
              justifyContent="left"
              alignItems="center"
              sx={{color: '#3E9FDD', cursor: 'pointer', marginBottom: '4px'}}
              onClick={handleToggleClick}
              flexWrap={'wrap'}>
              <ArrowDropDownIcon
                className="linkArrow"
                aria-label="Voir plus"
                sx={{marginLeft: -0.4}}
              />
              <Typography variant={'subtitle11'}>
                {expandMore ? 'Afficher moins' : "Lire l'article en entier"}
              </Typography>
            </Stack>
            {joinStatus.isJoin === true ? (
              <Button
                className="btn-gradient"
                variant="contained"
                startIcon={
                  <LogoutIcon role="img" aria-label={'Quitter cet événement'} />
                }
                sx={{width: '300px'}}
                onClick={() => handleClickJoin(false)}
                aria-label={'Quitter cet événement'}>
                <Typography variant={'subtitle11'}>
                  Quitter cet événement
                </Typography>
              </Button>
            ) : (
              <Button
                className="btn-gradient"
                variant="contained"
                startIcon={
                  <LoginIcon
                    role="img"
                    aria-label={'Rejoindre cet événement'}
                  />
                }
                sx={{width: '300px'}}
                onClick={() => handleClickJoin(true)}
                aria-label={'Rejoindre cet événement'}>
                <Typography variant={'subtitle11'}>
                  Rejoindre cet événement
                </Typography>
              </Button>
            )}
          </Stack>
        </Stack>
      </Stack>

      {expandComment ? <EventComment contentId={theEvent.id} /> : <></>}
    </Stack>
  );
};

export default withJoinContext(EventExpandLess);
